import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

const ADDRESS_FIELDS = gql`
  fragment addressFields on BusinessAddress {
    address1
    address2
    city
    state
    zip
  }
`;

export const GET_PROFILE_QUERY = gql`
  query ProfileQuery($businessEntityUuid: UUID!) {
    businessEntity: businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      name
      type
      domesticJurisdiction
      createdAt
      updatedAt
      formationDate
      ein
      addresses {
        mailing {
          ...addressFields
        }
        principal {
          ...addressFields
        }
      }
    }
    registeredAgents: registeredAgents(businessEntityUuid: $businessEntityUuid) {
      uuid
      contact {
        companyName
        firstName
        lastName
        address1
        address2
        city
        state
        zip
      }
    }
  }
  ${ADDRESS_FIELDS}
`;

export function useBusinessProfile() {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, errors } = useQuery(GET_PROFILE_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid
    }
  });

  useError(errors);

  return {
    data,
    error: errors?.[0],
    loading
  };
}
